import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ApplicationSettingsType } from '@fi-shared/types/application-settings-type';
import { AccessRightType } from '@fi-shared/types/access-right-type';
import { AccessToApplicationTypeService } from '@fi-shared/fi-shared-services/access-to-application-type.service';
import { SessionService } from '@fi-app/utilities/fi-services/session.service';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';
import { FiStateNames } from '@fi-shared/fi-state-proxy/fi-state-names';

@Component({
    selector: 'fi-checklist-template-view',
    templateUrl: './checklist-template-view.component.html',
    encapsulation: ViewEncapsulation.None,
    styleUrls: ['./checklist-template-view.component.scss'],
    standalone: false,
})
export class FiChecklistTemplateViewComponent implements OnInit {
    @Input() checklist;
    HasEditAccess;
    selectedLanguage;
    FiStateNames = FiStateNames;

    constructor(
        private accessToApplicationTypeService: AccessToApplicationTypeService,
        private sessionService: SessionService,
        private userDataService: FiUserDataService,
    ) {}

    ngOnInit() {
        const isAdminRights = this.accessToApplicationTypeService.HasAccessToApplicationType(
            ApplicationSettingsType.ChecklistLocal,
            AccessRightType.Admin,
        );

        this.HasEditAccess =
            this.checklist.CreatedByUserId === this.userDataService.getUserId() ||
            (isAdminRights && this.checklist.AccessRightFilterCollection.HasEditAccess);
    }
}
